import { api, auth } from '@/f1/service';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
// import ipList from '../ipList';
import ipList from '../IpList.i18n'
import 'vue-select/dist/vue-select.css';
import _ from 'lodash'
import reg from '@/f1/reg'
import ActionList from '../../log/Action.i18n'
import Language from './language';

//restful api
import { management } from '@/f1/service/api'

//i18n_data
import i18n_toast from './i18n_data'
import i18n_data from '@/component/i18n_data';

// const _i18n_data = {
//   saved: {
//     EN : `saved`,
//     KO : `저장되었습니다`,
//     JP : `saved`,
//   },
//   removed: {
//     EN : `removed`,
//     KO : `삭제되었습니다`,
//     JP : `removed`,
//   },
// };

const default_model = () => ({
  is_alive: true, permissions: '',
  security_policy : {
    account_lock_count : 5,
    account_lock_time : 5,
    password_min_len : 10,
    password_use_spacial : true,
    password_use_alphabet : true,
    password_use_number : true,
    timeout : 300,
  },
  allow_ip_agent : [],
  allow_ip_account : []
});

export default {
  components: {
    Language,
    ActionList,
    cSwitch,
    vSelect,
    ipList,
  },
  data : () => ({
    // 시스로그 알림 범위 설정
    // syslog
    syslog_setting : {
      is_allow_mode_block : false,
      is_allow_mode_detect : true,
      is_allow_severity_emergency : false,
      is_allow_severity_alert : false,
      is_allow_severity_critical : false,
      is_allow_severity_error : false,
      is_allow_severity_warning : false,
      is_allow_severity_info : false,
    },
    log_format: [
      { Fields: 'Facility', Value: 'LogAlert(14)' },
      { Fields: 'Serverity', Value: 'SecurityAlert(1)' },
      { Fields: 'HostName', Value: 'SecaaS' },
      { Fields: 'ProcId', Value: '-' },
      { Fields: 'AppName', Value: 'svc.[wsfinder|webcastle|wmds]' },
      { Fields: 'MsgId', Value: 'Reference id(key)' },
      { Fields: 'Message', Value: 'Message Format' },
    ],
    log_format_case: [
      { 'Type': 'WEBCastle', 'Attacker': '1.1.1.1', 'Victim(Target)' : '1.1.1.1', 'Name': 'agent name', 'Action' : '[block|detection]' },
      { 'Type': 'WSFinder', 'Attacker': '-', 'Victim(Target)' : '/var/www/sehll.php', 'Name': 'agent.name@agent.ip', 'Action' : '[detection|isolation|forgery]' },
      { 'Type': 'WMDS', 'Attacker': '-', 'Victim(Target)' : 'https://a.com/v.exe', 'Name': 'site name', 'Action' : '[detect|forgery]' },
    ],
    index : 0,
    auth : auth,
    modal : {
      explain : false,
      confirm : false,
      title : '',
      msg : ''
    },
    add: false,
    lock: true,
    users: [],
    model : default_model(),
    old_username : '',
    allowed: false,
    // 해지 관련 변수 추가
    status : {
      all_bill_pay : false,
      processing : false,
      approve : false
    },
  }),
  computed: {
    // i18n_data() { return _i18n_data; },
    profile() { return auth.profile; },
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; },
    fields() {
      return [
        { key: 'id', thStyle: 'width: 10%', label: 'No.' },
        { key: 'group.groupname', sortable: true, label: 'Group' },
        { key: 'permissions', label: 'Level' },
        { key: 'is_alive', label: 'Status' },
        { key: 'username', sortable: true, label: 'Username'},
        { key: 'nickname', sortable: true, label: 'Nickname' },
        { key: 'last_visit', label: 'Last login', sortable: true },
        { key: 'func', label: 'Detail', sortable: false, thStyle: 'width: 10%'  },
    ]}
  },
  methods: {
    notice() {
      // return this.$toastr.i('plz, wait partner or manager review')
      return this.$toastr.i(`${i18n_toast._i18n_info.notice[this.i18n]}`)
    },
    // 해지 절차 추가
    signout_status: function() {
      console.log('start signout status process')
      api.board.Billing_Call('group', 'signout.status', { group_id : this.model.id }).then(rs => {
        if(rs.error) {
          // return this.$toastr.e(rs.reason, this.$route.name)
          return this.$toastr.e(`${i18n_toast._i18n_error.signout[this.i18n]}`, this.$route.name)
        }
        this.status = Object.assign({}, this.status, rs.body);
      }).catch(e => { this.$toastr.e(e.data ? `${i18n_toast._i18n_error.signout[this.i18n]}` : e.data.message || e.data.message ? e.data.title : e.statusText) })
    },
    signout_cancel: function() {
      console.log('start signout cancel process')
      if(!this.status.processing) {
        // return this.$toastr.e("STEP.2 resolve first");
        return this.$toastr.e(`${i18n_toast._i18n_error.status_processing[this.i18n]}`);
      }
      api.board.Billing_Call('group', 'service.continue', { group_id : this.model.id }).then(rs => {
        if(rs.error) {
          // return this.$toastr.e(rs.reason, this.$route.name)
          return this.$toastr.e(`${i18n_toast._i18n_error.signout_cancel[this.i18n]}`, this.$route.name)
        }
        // this.$toastr.s("The service interruption received has been canceled.")
        this.$toastr.s(`${i18n_data._i18n_success.service_cancel[this.i18n]}`)
        this.status = Object.assign({}, this.status, { processing : false })
      }).catch(e => { this.$toastr.e(e.data ? `${i18n_toast._i18n_error.signout_cancel[this.i18n]}` : e.data.message || e.data.message ? e.data.title : e.statusText) })
    },
    signout_stop() {
      console.log("start stopping of plan")
      // if(!this.status.all_bill_pay) { return this.$toastr.e("STEP.1 resolve first"); }
      api.board.Billing_Call('group', 'service.stop', { group_id : this.model.id }).then(rs => {
        if(rs.error) {
          // return this.$toastr.e(rs.reason, this.$route.name)
          return this.$toastr.e(`${i18n_toast._i18n_error.signout_stop[this.i18n]}`, this.$route.name)
        }
        // this.$toastr.s("request stopping service")
        this.$toastr.s(`${i18n_toast._i18n_success.stop[this.i18n]}`)
        this.status = Object.assign({}, this.status, { processing : true })
      }).catch(e => { this.$toastr.e(e.data ? `${i18n_toast._i18n_error.signout_stop[this.i18n]}` : e.data.message || e.data.message ? e.data.title : e.statusText) })
    },
    request_billing() {
      console.log("start request_billing")
      api.board.Billing_Call('group', 'service.billing', { group_id : this.model.id }).then(rs => {
        if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) }
        // this.$toastr.s("A bill has been issued this month.")
        this.$toastr.s(`${i18n_toast._i18n_success.billing[this.i18n]}`)
      }).catch(e => { this.$toastr.e(e.data.message, e.status, e.statusText) })
    },
    // ip 변경
    ip_remove(i, t) {
      console.log('ip_remove', i, t)
      console.log(i, t)
      if(t == 'account') { this.model.allow_ip_account.splice(i, 1) }
      else { this.model.allow_ip_agent.splice(i, 1) }
    },
    ip_add(i, t) {
      if(!i) {
        // return this.$toastr.w("no have ip address");
        return this.$toastr.w(`${i18n_toast._i18n_warning.ip_check[this.i18n]}`);
      }
      if(t == 'account') {
        if((this.model.allow_ip_account || []).indexOf(i) > -1) {
          // return this.$toastr.w("ip address exist")
          return this.$toastr.w(`${i18n_toast._i18n_warning.ip_check[this.i18n]}`);
        }
        // CC 인증에서 2개가 맥스로 지정하게  되어있음, 근거 보안관리 요구사항 중 4.4.2
        if((this.model.allow_ip_account || []).length >= 2) {
          // return this.$toastr.e("only allow 2 ip address")
          return this.$toastr.e(`${i18n_toast._i18n_error.ip_check3[this.i18n]}`);
        }
        this.model.allow_ip_account.push(i)
      } else {
        if((this.model.allow_ip_agent || []).indexOf(i) > -1) {
          // return this.$toastr.w("ip address exist")
          return this.$toastr.w(`${i18n_toast._i18n_warning.ip_check2[this.i18n]}`);
        }
        this.model.allow_ip_agent.push(i)
      }
    },
    ip_clear(t) {
      if(t == 'account') { this.model.allow_ip_account = [] }
      else { this.model.allow_ip_agent = [] }
    },
    validate_ip(ips) {
      let ip_list = typeof ips == 'string' ? (ips || '').split('\n') : ips;
      let rv = [];
      _.forEach(ip_list, ip => {
        let addr = ip.split(':')
        if(addr.length > 1) {
          if(reg.ip4.test(addr[0]) || reg.ip4_range.test(addr[0])) { rv.push(_.join(addr, ':')); }
        } else {
          if(reg.ip4.test(ip) || reg.ip4_range.test(ip)) { rv.push(ip); }
        }

      })
      return rv;
    },
    // async refresh_users() { try { this.users = await api.member.group.users(this.model.id); } catch(e) { } },
    // 기본 CRUD 함수 시작
    cancel() { this.$router.replace({ name: 'group', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'group', params: { tag: 'edit' }}); },
    async remove() {
      try {
        // await api.member.group.delete(this.model.id);
        await api.management.group.delete({ id : this.model.id });
        this.$emit('refresh'); this.$toastr.s(`${i18n_data._i18n_success.removed[this.i18n]}`); this.list();
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.remove_failed[this.i18n]}` : e.data || e); this.list(); }
    },
    list() { this.$router.push({ name: 'group'}); },
    async save() {
      if(!(this.model.groupname || '').trim()) {
        // return this.$toastr.e('Name required.');
        return this.$toastr.e(`${i18n_toast._i18n_error.name_req[this.i18n]}`);
      }
      if(this.model.group && this.model.group.id) { this.model.group_id = this.model.group.id; }
      try {

        let body = undefined;
        // 저장관련 메소드 미사용 4
        switch (this.index) {
          case 0:
            body = Object.assign({}, body, { groupname : this.model.groupname, address : this.model.address })
            break;
          case 1:
            // security policy 저장
            // 그룹 전체에 적용되는 IP 접근제어 설정 저장
            if(this.model.security_policy.timeout == '') { this.model.security_policy.timeout = 600 }
            body = Object.assign({}, body, { allow_ip_agent : this.model.allow_ip_agent, allow_ip_account : this.model.allow_ip_account, security_policy : this.model.security_policy })
            body.allow_ip_agent = this.validate_ip(body.allow_ip_agent)
            body.allow_ip_account = this.validate_ip(body.allow_ip_account)
            // console.log(body.security_policy)
            break;
          case 2:
            // syslog, 메일 수신 여부, 싱글 로그인 설정
            if(this.model.syslog_list) {
              body = Object.assign({}, body, { syslog : _.uniq(_.compact(this.model.syslog_list.replace(/,/g, '').split("\n"))) })
              body.syslog = this.validate_ip(body.syslog)

              // b-form-textarea has bug, can not bind model so rirect update
              body.syslog_list = _.join(body.syslog, '\n')
              this.$refs.syslog_list.localValue = body.syslog_list
            } else {
              body = Object.assign({}, body, { syslog : '', syslog_list : '' })
              this.model.syslog_list = this.model.syslog = body.syslog
            }

            // email_cc
            if(this.model.email_cc_list) {
              body = Object.assign({}, body, { email_cc : _.uniq(_.compact(this.model.email_cc_list.replace(/,/g, '').split("\n"))) })

              // b-form-textarea has bug, can not bind model so rirect update
              body.email_cc_list = _.join(body.email_cc, '\n')
              this.$refs.email_cc_list.localValue = body.email_cc_list
            } else {
              body = Object.assign({}, body, { email_cc : '', email_cc_list : '' })
              this.model.email_cc_list = this.model.email_cc = body.email_cc
            }

            body = Object.assign({}, body, { single_login : this.model.single_login, allow_mail : this.model.allow_mail })

            break;
          case 3:
            break;
        }
        if(!body) {
          // return this.$toastr.e("require data for update");
          return this.$toastr.e(`${i18n_toast._i18n_error.list[this.i18n]}`);
        }
        body.id = this.model.id
        body.syslog_setting = this.syslog_setting

        // let rs = await api.member.Manager_Call('group', 'update', body);
        let rs = await api.management.group.update(body);
        if(rs.error) {
          // return this.$toastr.e("save failed")
          return this.$toastr.e(`${i18n_data._i18n_error.saved_failed[this.i18n]}`)
        }
        this.$toastr.s(`${i18n_data._i18n_success.saved[this.i18n]}`);
        this.$emit('refresh'); this.cancel();
      } catch(e) { console.log(e); this.$toastr.e(e.data ? `${i18n_data._i18n_error.save_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText); this.cancel() }
      this.lock = true;
    },
    async get({tag} = this.$route.params) {
      console.log('[vue] group.detail', 'load item');
      delete this.model.new_password;
      delete this.model.new_password_repeat;

      this.lock = (tag !== 'edit');

      try {
        let id = auth.profile.group_id;
        // await api.member.Manager_Call('group','detail',{id : id}).then(rs => {
        await management.group.detail({id : id}).then(rs => {
          if(rs.error) {
            // return this.$toastr.e("load failed")
            return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`);
          }
          this.model = Object.assign({group:{}}, default_model(), this.model, rs.body)
        }).then(() => {
          this.model = Object.assign({}, default_model(), this.model)
          this.model.syslog_list = this.model.syslog ? this.model.syslog.join("\n") : ''
          this.model.email_cc_list = this.model.email_cc ? this.model.email_cc.join("\n") : ''

          this.syslog_setting = Object.assign({}, this.syslog_setting, this.model.syslog_setting)

          if(!this.model.security_policy.timeout) {
            this.model.security_policy.timeout = default_model().security_policy.timeout
          }
          // this.status.processing = this.model.bill_end_at ? true : false;
          // console.log(this.model.security_policy)
         }).catch(e => this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message || e.data ? e.data.title : e.statusText));
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText); }
    },
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log('from', from) } },
  created() { console.log('[vue] group.detail', 'created'); },
  destroyed() { console.log('[vue] group.detail', 'destroyed'); },
  mounted() {
    console.log('[vue] group.detail', 'mounted');
    this.get();
    if(location.hostname == 'localhost') { this.index = 1 }
  },
}
